import React from 'react';
import './ArchitecturalServices.css'; // Use the same CSS file
import useScrollToTop from './useScrollToTop';
import ReusableLanding from './ReusableLanding';
import image2 from '../img/kitchen_modern_classic.png';
import {FaFillDrip,FaScrewdriver, FaRulerHorizontal, FaCubes,  FaSearch, FaHome, FaShieldAlt, FaCheckCircle, FaMapMarkedAlt, FaPencilRuler, FaBars, } from 'react-icons/fa'; // Import relevant icons
import { Link } from 'react-router-dom';

const FootingConstruction = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Footing Construction"
                description="A strong foundation is crucial for any building. At Housekaar, we specialize in footing construction, ensuring your structure rests on a solid and reliable base."
            />
            <div className="architectural-services-page">
                <section className="services-overview">
                    <h2>Our Footing Construction Services</h2>
                    <p>We provide expert footing construction services, laying the groundwork for a stable and durable structure.</p>
                    <ul className="services-list">
                        <li><FaRulerHorizontal className="service-icon" /> <strong>Foundation Layout:</strong> Precise marking and accurate setting of footing locations according to the approved building plans.</li>
                        <li><FaCubes className="service-icon" /> <strong>Excavation:</strong> Careful and proper digging and preparation of footing trenches, ensuring correct dimensions and soil conditions.</li>
                        <li><FaBars className="service-icon" /> <strong>Reinforcement Installation:</strong> Precise placement and secure tying of steel rebar within the footing trenches to provide essential structural integrity.</li>
                        <li><FaFillDrip className="service-icon" /> <strong>Concrete Pouring:</strong> Expert pouring, leveling, and finishing of high-quality concrete to form the solid and reliable footing structure.</li>
                        <li><FaSearch className="service-icon" /> <strong>Inspection and Quality Control:</strong> Thorough inspections conducted at each stage to ensure footings meet all relevant building codes, structural standards, and project specifications.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Our Footing Construction</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="benefit-icon"><FaHome /></div>
                            <h3>Structural Stability</h3>
                            <p>Providing a robust and unwavering base that ensures the overall stability and safety of your entire building structure.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaShieldAlt /></div>
                            <h3>Long-Term Durability</h3>
                            <p>Utilizing high-quality concrete and proper construction techniques to create footings that will withstand the test of time and environmental factors.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaScrewdriver /></div>
                            <h3>Prevention of Settlement</h3>
                            <p>Ensuring the even distribution of the building's weight across the soil, minimizing the risk of differential settlement and potential structural damage.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaCheckCircle /></div>
                            <h3>Compliance with Standards</h3>
                            <p>Strictly adhering to all local building codes, regulations, and engineering specifications to ensure a safe and legally compliant foundation.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>We follow a meticulous and step-by-step process for reliable footing construction.</p>
                    <ol className="process-list">
                        <li><FaMapMarkedAlt className="process-icon" /> <strong>Site Assessment:</strong> Carefully evaluating soil bearing capacity, site topography, and reviewing building plans and structural engineering drawings.</li>
                        <li><FaPencilRuler className="process-icon" /> <strong>Layout and Excavation:</strong> Precisely marking the footing layout based on the plans and excavating the trenches to the specified dimensions and depth.</li>
                        <li><FaBars className="process-icon" /> <strong>Reinforcement and Formwork:</strong> Accurately installing the steel reinforcement bars according to the structural design and setting up the necessary formwork to contain the concrete pour.</li>
                        <li><FaFillDrip className="process-icon" /> <strong>Concrete Pouring and Curing:</strong> Pouring the concrete in layers, ensuring proper compaction, leveling the surface, and allowing for adequate curing time to achieve maximum strength.</li>
                        <li><FaSearch className="process-icon" /> <strong>Inspection and Backfilling:</strong> Conducting a final inspection of the completed footings to verify compliance before carefully backfilling the trenches with appropriate material.</li>
                    </ol>
                </section>

                <section className="get-started-cta">
                    <h2>Build on a Solid Foundation with Housekaar</h2>
                    <p>
                        Contact us today to discuss your footing construction needs. Let our expertise provide the strong and dependable foundation your building project deserves.
                    </p>
                    <Link to="/pricing">
                        <button className="custom-button">Contact Us</button>
                    </Link>
                </section>
            </div>
        </>
    );
};

export default FootingConstruction;